import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDocuments = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 42,
	height: 42,
	viewBox: "0 0 42 42",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 21,
			cy: 21.0039,
			r: 21,
			fill: "#F0EEFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.6602 19.4444L29.6802 23.6244C28.8402 27.2344 27.1802 28.6944 24.0602 28.3944C23.5602 28.3544 23.0202 28.2644 22.4402 28.1244L20.7602 27.7244C16.5902 26.7344 15.3002 24.6744 16.2802 20.4944L17.2602 16.3044C17.4602 15.4544 17.7002 14.7144 18.0002 14.1044C19.1702 11.6844 21.1602 11.0344 24.5002 11.8244L26.1702 12.2144C30.3602 13.1944 31.6402 15.2644 30.6602 19.4444Z",
			stroke: "#7548F0",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.0584 28.3935C23.4384 28.8135 22.6584 29.1635 21.7084 29.4735L20.1284 29.9935C16.1584 31.2735 14.0684 30.2035 12.7784 26.2335L11.4984 22.2835C10.2184 18.3135 11.2784 16.2135 15.2484 14.9335L16.8284 14.4135C17.2384 14.2835 17.6284 14.1735 17.9984 14.1035C17.6984 14.7135 17.4584 15.4535 17.2584 16.3035L16.2784 20.4935C15.2984 24.6735 16.5884 26.7335 20.7584 27.7235L22.4384 28.1235C23.0184 28.2635 23.5584 28.3535 24.0584 28.3935Z",
			stroke: "#7548F0",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.6406 17.5332L26.4906 18.7632",
			stroke: "#7548F0",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.6602 21.4043L23.5602 22.1443",
			stroke: "#7548F0",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgDocuments;
